import React from "react";

// Error summary component with inline styles to ensure they're applied
const ValidationErrorSummary = ({ validateForm, showErrors }) => {
  // Only show errors when showErrors state is true
  if (!showErrors || validateForm.isValid || validateForm.errors.length === 0) {
    return null;
  }

  // Group errors by question index for better organization
  const groupedErrors = validateForm.errors.reduce((acc, error) => {
    const key = `question-${
      error.questionIndex !== undefined ? error.questionIndex + 1 : "general"
    }`;

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(error);
    return acc;
  }, {});

  const styles = {
    container: {
      marginTop: "20px",
      border: "1px solid #e74c3c",
      padding: "20px",
      borderRadius: "8px",
      backgroundColor: "#fef5f5",
      boxShadow: "0 2px 8px rgba(231, 76, 60, 0.15)",
    },
    heading: {
      color: "#2c3e50",
      marginTop: 0,
      marginBottom: "16px",
      fontSize: "18px",
      fontWeight: "600",
      borderBottom: "2px solid #e74c3c",
      paddingBottom: "12px",
    },
    subheading: {
      margin: "16px 0 10px",
      fontSize: "16px",
      fontWeight: "600",
      color: "#2c3e50",
    },
    list: {
      margin: "8px 0",
      paddingLeft: "0",
      listStyleType: "none",
    },
    listItem: {
      marginBottom: "10px",
      paddingLeft: "24px",
      position: "relative",
      color: "#34495e",
      lineHeight: "1.6",
      fontSize: "14px",
    },
    bullet: {
      position: "absolute",
      left: "8px",
      top: "8px",
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      backgroundColor: "#e74c3c",
      display: "inline-block",
    },
    errorField: {
      textTransform: "capitalize",
      fontWeight: "600",
      color: "#e74c3c",
      marginRight: "6px",
    },
    errorMessage: {
      color: "#34495e",
    },
    errorCount: {
      marginTop: "20px",
      fontWeight: "600",
      color: "#2c3e50",
      fontSize: "15px",
      borderTop: "2px solid #e74c3c",
      paddingTop: "12px",
    },
    errorGroup: {
      marginBottom: "20px",
    },
    errorList: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start ',
      alignItems: 'flex-start',
      gap: '20px',
      flexWrap: 'wrap'
    }
  };

  return (
    <div style={styles.container}>
      <h3 style={styles.heading}>
        Please fix the following issues before saving:
      </h3>
      <div style={styles.errorList}>
      {Object.keys(groupedErrors).map((groupKey) => {
        const questionNumber = groupKey.replace("question-", "");
        const errorsForQuestion = groupedErrors[groupKey];

        return (
          <div key={groupKey} style={styles.errorGroup}>
            <h4 style={styles.subheading}>
              {questionNumber === "general"
                ? "General Issues"
                : `Question ${questionNumber} Issues`}
            </h4>
            <ul style={styles.list}>
              {errorsForQuestion?.map((error, index) => (
                <li key={index} style={styles.listItem}>
                  <span style={styles.bullet}></span>
                  <span style={styles.errorField}>{error.field}:</span>
                  <span style={styles.errorMessage}>{error.message}</span>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
      </div>

      <div style={styles.errorCount}>
        Total issues: {validateForm.errors.length}
      </div>
    </div>
  );
};

export default ValidationErrorSummary;
